






import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class NumEntries extends Vue {
  
  @Prop({ default: '',  type: String}) entryName!: string;
  @Prop({ default: 0,  type: Number}) numEntries!: number;
  @Prop({ default: 1000,  type: Number}) overflowNum!: number;
  @Prop({ default: false,  type: Boolean}) exactNumber!: boolean;
  @Prop({ default: 's',  type: String}) pluralIndicator!: string;

  get displayNumEntries():string {

    if(this.exactNumber)
      return `${this.numEntries}`;

    return this.numEntries < this.overflowNum ? `${this.numEntries}` : `${this.numEntries}+`;
  }

  get singleEntry():boolean {
    return this.numEntries === 1;
  }

  get noEntry():boolean {
    return this.numEntries === 0;
  }
}
